import styled from 'styled-components';
import {link} from 'styles/fragments';

export default styled.a`
	${link};
`;
